export const PROFILE_TAX_ERROR = 'PROFILE_TAX_ERROR';
export const PROFILE_TAX_LOADING = 'PROFILE_TAX_LOADING';
export const PROFILE_TAX_SUCCESS = 'PROFILE_TAX_SUCCESS';